import * as z from "zod/v4";

export const sendInternationalReturnsWaitlistNotification = {
  name: "sendInternationalReturnsWaitlistNotification" as const,
  input: z.null(),
  output: z.null(),
};
